import Base from './components/cells/Base';
import Time from './components/cells/Time';

export default function DateCell() {}

DateCell.prototype.init = function (params) {
    this.eGui = Base(Time(params), params);
    return;
};

DateCell.prototype.getGui = function () {
    return this.eGui;
};
